import { Dexie, EntityTable } from 'dexie';
import { LogCacheType } from './dbEntityTypes';

export type LitholensLocalDatabaseType = Dexie & {
  logCache: EntityTable<LogCacheType>;
};

export const createDatabase = (company: string, projectId: string) => {
  const db = new Dexie(
    `litholens-${company}-${projectId}`,
  ) as LitholensLocalDatabaseType;

  db.version(1).stores({
    logCache: '[id+drillhole]',
  });

  db.open();

  return db;
};
